import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewEncapsulation,
} from '@angular/core';
import { AXFWidgetView } from '../../../config/widget';

@Component({
  selector: 'tr',
  templateUrl: './table-row-widget.view.html',
  styleUrls: ['./table-row-widget.view.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class AXFTableRowWidgetView extends AXFWidgetView {
  rIndex!: number;

  constructor(private el: ElementRef, private cdr: ChangeDetectorRef) {
    super();
  }

  override onRender() {
    const el = this.el.nativeElement as HTMLElement;
    this.applyStyle(el);
    if (this.visible === false) {
      el.style.display = 'none';
    } else if (el.style.display === 'none') {
      el.style.display = '';
    }
    this.cdr.markForCheck();
  }
}
